import { useMemo } from "react";
import type { FonteDaFoto } from "@foto/shared";
import { VisorDeImagem } from "../../components/VisorDeImagem.js";
import { fonteDoVisor, tituloDaFoto, versaoInicialDaFoto, versoesDaFoto } from "./ampliar-fotos.js";
import type { FotoNaBandeja } from "./folhas.js";

/**
 * O visor com zoom de uma foto publicada, com as versões que ela tem — "Peça com capa", "Foto da IA" e,
 * na Impressão, "Foto original" — para comparar e conferir antes de escolher. É o que a lupa das miniaturas abre, nos Marcadores e na
 * Impressão.
 *
 * `acao` é o botão principal da tela que abriu ("Usar esta foto", "Colocar na folha"): recebe a versão
 * que estava à vista quando se tocou nele, e o visor fecha.
 */
export function VisorDaFoto({
  foto,
  versao,
  comOriginal = false,
  acao,
  aoFechar,
}: {
  foto: FotoNaBandeja;
  /** Oferece também a foto original (a Impressão; os Marcadores, não). */
  comOriginal?: boolean;
  /** A versão que a grade mostrava: o visor abre nela, se a foto a tem. */
  versao: FonteDaFoto;
  acao?: { rotulo: string; aoAcionar: (versao: FonteDaFoto) => void } | undefined;
  aoFechar: () => void;
}) {
  const versoes = useMemo(() => versoesDaFoto(foto, { comOriginal }), [foto, comOriginal]);
  const titulo = tituloDaFoto(foto.nome);
  return (
    <VisorDeImagem
      titulo={titulo}
      alt={titulo}
      versoes={versoes}
      versaoInicial={versaoInicialDaFoto(foto, versao, { comOriginal })}
      acao={
        acao && {
          rotulo: acao.rotulo,
          // Os `id` das versões são os de `FonteDaFoto`.
          aoAcionar: (id) => acao.aoAcionar(fonteDoVisor(id)),
        }
      }
      aoFechar={aoFechar}
    />
  );
}
